import {Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import moment from 'moment';

@Component({
    selector: 'bb-date-input-form',
    templateUrl: './date-input-form.component.html',
    styleUrls: ['./date-input-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DateInputFormComponent),
            multi: true,
        },
    ]
})
export class DateInputFormComponent implements OnInit, OnChanges {
    @Input() label: string;
    @Input() id: string;
    @Input() min: string;
    @Input() max: string;
    @Input() format = 'MM/dd/YYYY hh:mm aa';
    @Input() hideIcon = false;
    @Input() presentation = 'date-time';
    @Input() minuteValues = '0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,';
    @Output() dateChange = new EventEmitter();

    field: string;
    formattedField: string;
    formattedMax: string;
    formattedMin: string;

    initialized = false;

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!!changes.max) {
            this.formattedMax = this.initializeDate(this.max);
        }
        if (!!changes.min) {
            this.formattedMin = this.initializeDate(this.min);
        }
    }

    setDefault() {
        this.field = !!this.field ? this.field : moment().format();
    }

    writeValue(obj: any): void {
        if (!this.initialized && this.presentation !== 'time') {
            this.field = this.initializeDate(obj);
            this.initialized = true;
        } else {
            this.field = this.convert(obj);
        }
        this.formattedField = this.formatDate(this.field);
    }

    onChange = (value: any) => {
    };

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
    }

    setDisabledState?(isDisabled: boolean): void {
    }

    initializeDate(obj) {
        return !!obj ? moment(this.convert(obj)).local().format() : undefined;
    }

    convert(obj) {
        let val = obj;
        if (!!val && this.presentation !== 'time') {
            if (val.includes('.')) {
                const s = val.split('.');
                let index = s[1].indexOf('-');
                if (index === -1) {
                    index = s[1].indexOf('+');
                }
                if (index === -1) {
                    index = s[1].indexOf('Z');
                }
                val = s[0] + s[1].substring(index);
            }
        }
        return val;
    }

    formatDate(val: string) {
        if (this.presentation !== 'time') {
            if (!!val) {
                return new Date(Date.parse(val)).toLocaleString('en-US');
            } else {
                return '';
            }
        } else {
            if (!!val && val.indexOf(':') > 0) {
                const s = val.split(':');
                return `${s[0]}:${s[1]}`;
            } else {
                return val;
            }
        }
    }

    fireDateChange(event) {
        const value = event.detail.value;
        if (value !== this.field) {
            this.dateChange.emit(event.detail.value);
        }
    }
}
